import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ModalNewModuleComponent } from './modal-new-module/modal-new-module.component';
import { ModalAddResourceComponent } from './modal-add-resource/modal-add-resource.component';
import { FormsModule } from '@angular/forms';
import { ModalNewClientComponent } from './modal-new-client/modal-new-client.component';
import { MenuModule } from 'primeng/menu';
import { ModalAddModuleClientComponent } from './modal-add-module-client/modal-add-module-client.component';
import { ModalNewRoleComponent } from './modal-new-role/modal-new-role.component';
import { HeaderViewsComponent } from './header-views/header-views.component';
import { DropdownModule } from 'primeng/dropdown';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipesModule } from 'projects/access-control/src/app/Infrastructure/pipes/pipes.module';
import { ModalAlertComponent } from './modal-alert/modal-alert.component';
import { ModalNewGroupComponent } from './modal-new-group/modal-new-group.component';
import { ModalAddFieldComponent } from './modal-add-field/modal-add-field.component';
import { ModalDesignFormComponent } from './modal-design-form/modal-design-form.component';
import { EditorModule } from 'primeng/editor';
import { PasswordModule } from 'primeng/password';
import { ModalUsersComponent } from './modal-users/modal-users.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ModalStatusGroupsComponent } from './modal-status-groups/modal-status-groups.component';
import { DirectivesModule } from 'projects/access-control/src/app/Infrastructure/directive/directives.module';
import { CommonsModule } from '../commons/commons.module';
import { loadingSpinnerModule } from '../commons/loading-spinner/loading-spinner.module';
import { SubSidebarModule } from '../commons/sub-sidebar/sub-sidebar.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { NgSelectModule } from '@ng-select/ng-select';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import { S3UploadModule } from '@mangosoft/mango-layout';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { ModalNewVersionComponent } from './modal-new-version/modal-new-version.component';

@NgModule({
	declarations: [
		ModalNewModuleComponent,
		ModalAlertComponent,
		HeaderViewsComponent,
		ModalAddResourceComponent,
		ModalNewClientComponent,
		ModalAddModuleClientComponent,
		ModalNewRoleComponent,
		ModalNewGroupComponent,
		ModalAddFieldComponent,
    ModalNewVersionComponent,
		ModalDesignFormComponent,
		ModalUsersComponent,
		ModalStatusGroupsComponent,
	],
	exports: [
		ModalNewModuleComponent,
		ModalAlertComponent,
		HeaderViewsComponent,
		ModalAddResourceComponent,
		ModalNewClientComponent,
		ModalAddModuleClientComponent,
		ModalUsersComponent,
		ModalNewRoleComponent,
		ModalNewGroupComponent,
		ModalStatusGroupsComponent,
	],
	imports: [
		MultiSelectModule,
		CommonModule,
		BrowserModule,
		MatIconModule,
		NgSelectModule,
		ReactiveFormsModule,
		S3UploadModule,
		MatSelectModule,
		MatTooltipModule,
		BrowserAnimationsModule,
		PipesModule,
		InputSwitchModule,
		FormsModule,
		PasswordModule,
		NgxDatatableModule,
		MenuModule,
		DropdownModule,
		InfiniteScrollModule,
		EditorModule,
		CommonsModule,
		NgxIntlTelInputModule,
		DirectivesModule,
		DragDropModule,
		loadingSpinnerModule,
		SubSidebarModule,
		MatTreeModule,
		MatButtonModule,
	],
	providers: [],
})
export class ComponentsModule {}
